angular.module("ainapp")
    .controller("PUTenancyContractController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.PageName = "Purchase Tenancy Contract";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.KendoSource = new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {
                        MainService.PUTenancyContractsInView(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error("NetworkError");
                        })
                    }, 

                },
                change: function (data) {},
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            ReferanceNo: {
                                type: "string",
                                editable: false,
                            },
                            Place: {
                                type: "string",
                                editable: false,
                            },
                            Date: {
                                type: "date",
                                editable: false,
                            },
                            Type: {
                                type: "string",
                                editable: false,
                            },
                            PurposeOfRent: {
                                type: "string",
                                editable: false,
                            },
                            RentDuration: {
                                type: "string",
                                editable: false,
                            },
                            ContractType: {
                                type: "string",
                                editable: false,
                            },
                            PurposeOfRent: {
                                type: "string",
                                editable: false,
                            },
                            StartDate: {
                                type: "date",
                                editable: false,
                            },
                            ExpiryDate: {
                                type: "date",
                                editable: false,
                            },
                            GrandTotal: {
                                type: "number",
                                editable: false,
                            },
                            "Tenant.Name": {
                                type: "string",
                                editable: false,
                            },
                            "Lessor.Name": {
                                type: "string",
                                editable: false,
                            },
                            "Building.Name": {
                                type: "string",
                                editable: false,
                            },
                            "Flat.FlatNo": {
                                type: "string",
                                editable: false,
                            },

                        }
                    }
                },
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true,
                pageSize: 20,
            });

            $scope.KendoGridOptions = {

                editable: false,
                pageable: true,
                toolbar: ["excel"],
                height: 600,
                resizable: true,
                dataSource: $scope.KendoSource,
                pageSize: 20,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                sortable: true,
                scrollable: true,
                filterable: true,
                groupable: false,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },

                columns: [
                    {
                        field: "ReferanceNo",
                        title: "Ref No",
                        },
                    {
                        field: "Date",
                        title: "Date",
                        template: "#= kendo.toString(kendo.parseDate(Date, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                        },
                    {
                        field: "Tenant.Name",
                        title: "Tenant",
                        },
                    {
                        field: "Lessor.Name",
                        title: "Lessor",
                        },
                    {
                        field: "Building.Name",
                        title: "Building",
                        },
                    {
                        field: "Flat.FlatNo",
                        title: "Flat",
                        },
                    {
                        field: "Type",
                        title: "Type",
                        },
                    {
                        field: "ContractType",
                        title: "Contract Type",
                        },
                    {
                        field: "GrandTotal",
                        title: "Grand Total",
                        },
                    {
                        field: "RentDuration",
                        title: "Rent Duration",
                        },
                    {
                        field: "StartDate",
                        title: "Start Date",
                        template: "#= kendo.toString(kendo.parseDate(StartDate, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                        },
                    {
                        field: "ExpiryDate",
                        title: "Expiry Date",
                        template: "#= kendo.toString(kendo.parseDate(ExpiryDate, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                        },
                    {
                        title: "Options",
                        headerTemplate: "{{LanguageData.Options}}",
                        template: "<button class=' btn-default btn-sm fa fa-pencil' ng-click='Edit(dataItem)'> </button> <button class=' btn-default btn-sm fa fa-trash'  ng-click='DeleteAccType(dataItem)'></button>  <button class=' btn-default btn-sm fa fa-print'  ng-click=\"PrintInvoice(dataItem.Id, 'Tenancy Receipt', dataItem.ReferanceNo)\"></button>",
                        width: '100px'
                        },
                    ],
            };


            $scope.SelectedDataForDelete = {};
            $scope.DeleteAccType = function (data) {
                $scope.SelectedDataForDelete = data;
                $("#deleteModal").modal("show");
            }

            $scope.deleteWithConfirm = function () {
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });

                MainService.DeletePUTenancyContract($scope.SelectedDataForDelete.Id).then(function (response) {
                    if (response.data) {
                        $('#deleteModal').modal('hide');
                        toastr.success("Deleted");
                        $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                        $scope.SelectedDataForDelete = {};
                    }
                    $.LoadingOverlay("hide");
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.load = 0;
                    $.LoadingOverlay("hide");
                    $.LoadingOverlay("hide");

                });
            }

            $scope.Edit = function (data) {
                $state.go("editPUTenancyContract", {
                    VoucherId: data.Id
                })
            }



    }])
